var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.18 15.1c0-8.34-6.72-15.1-15-15.1-8.29 0-15 6.76-15 15.1 0 7.52 5.48 13.77 12.65 14.9V19.45h-3.8V15.1h3.8v-3.32c0-3.79 2.24-5.87 5.67-5.87 1.64 0 3.36.29 3.36.29v3.7h-1.9c-1.86 0-2.44 1.17-2.44 2.36v2.83h4.16l-.66 4.36h-3.5V30a15.07 15.07 0 0 0 12.66-14.9Z"
  })));
};
export default SvgFacebook;